// extracted by mini-css-extract-plugin
module.exports = {"noScrollbar":"TopPositionBreakdown_noScrollbar__K7VbZ"};